import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { decodeObjectStrings } from '@ftr/contracts/shared/sanitizer'
import { map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class HttpDecodeInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body) {
          return event.clone({ body: decodeObjectStrings(event.body) })
        }
        return event
      }),
    )
  }
}
